import type { NotificationRenderer } from "./types";
import { DocumentExpirationWidget } from "../DocumentExpirationWidget";
import { NotificationMetadataCard } from "../NotificationMetadataCard";
import { BodyCard } from "./BodyCard";

export const DocumentExpirationRenderer: NotificationRenderer = {
  render: (notification) => {
    const { daysRemaining, expirationDate, ...rest } =
      notification.metadata ?? {};

    const filteredMeta = Object.fromEntries(
      Object.entries(rest).filter(
        ([k]) => !["daysRemaining", "expirationDate"].includes(k),
      ),
    );

    return (
      <>
        <DocumentExpirationWidget
          daysRemaining={Number(daysRemaining ?? 0)}
          expirationDate={expirationDate}
        />
        <BodyCard body={notification.body} delay={0.15} />
        {Object.keys(filteredMeta).length > 0 && (
          <NotificationMetadataCard metadata={filteredMeta} />
        )}
      </>
    );
  },
};
